import { render, staticRenderFns } from "./custom-automated-message-instructions.vue?vue&type=template&id=44646852&"
import script from "./custom-automated-message-instructions.vue?vue&type=script&lang=js&"
export * from "./custom-automated-message-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports